module.exports = __webpack_public_path__ + "static/media/s_ssss.723fe1ff.mp3";